<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">药品智慧监管服务平台</div>
        <div
          class="desc"
        >药品智慧监管服务平台基于企业采集真实数据，通过对企业数据智能分析处理，为省药监局等药品监管单位提供基于真实数据的智慧监管手段，提升监管效率与监管的针对性。</div>
        <div>
          <p class="service">服务</p>
          <p class="fun">药品智慧监管服务平台主要有4个功能模块：</p>
          <img src="./images/img.png" alt />
        </div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product2.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from "components/product-banner";
export default {
  components: {
    productBanner
  }
};
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    .title
      line-height 70px
      color #0160B7
      font-size 30px
    .desc
      margin-top 4%
      line-height 1.5
      font-size 14px
      color #333333
    img
      width 100%
      margin-top 10px
  .service
    margin-top 8%
    font-size 18px
    color #333333
    margin-bottom 10px
  .fun
    color #666666
    font-size 14px
    margin-bottom 10px
  .list
    display flex
    justify-content space-between
    margin-top 22px
    .item
      line-height 58px
      width 24%
      font-size 14px
      text-align center
      border 1px dashed #287BFF
      background rgba(240, 246, 255, 1)
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
@media screen and (max-width: 1300px)
  .service
    margin-top 3% !important
</style>



// WEBPACK FOOTER //
// src/pages/ypzh/ypzh.vue